import {useEffect, useState} from "react";
import {AxiosRequestConfig, AxiosResponse} from "axios";

interface IAxiosLoader<T> {
    children: (data: T | null, error: any | null) => JSX.Element | null;
    method: <T = any, R = AxiosResponse<T>>(
        url: string,
        config?: AxiosRequestConfig | undefined,
    ) => Promise<R>;
    url: string;
    onLoaded?: () => void;
    config?: AxiosRequestConfig | any;
    debounce?: number;
}

export function AxiosLoader<T>({
                                   children,
                                   method,
                                   url,
                                   onLoaded,
                                   config,
                                   debounce,
                               }: IAxiosLoader<T>) {
    const [data, setData] = useState<T | null>(null);
    const [error, setError] = useState();

    useEffect(() => {
        debounce = debounce ?? 0;
        if (debounce > 0) {
            const timeout = setTimeout(() => {
                if (method && url) {
                    method(url, config)
                        .then((value) => {
                            setData(value.data);
                            if (onLoaded) onLoaded();
                        })
                        .catch((data) => {
                            setError(data?.response?.data ?? {"": ["Nepoznata greška"]});
                        });
                }
            }, debounce);
            return () => {
                clearTimeout(timeout);
                setData(null);
            };
        } else {
            if (method && url) {
                method(url, config)
                    .then((value) => {
                        setData(value.data);
                        if (onLoaded) onLoaded();
                    })
                    .catch((data) => {
                        setError(data?.response?.data ?? {"": ["Nepoznata greška"]});
                    });
            }
        }
    }, [method, url, config, debounce]);

    return children(data, error);
}
